import { cn } from "../../utils/cn";

export function ArrowRightIcon({ className }: { className?: string }) {
  return (
    <div className={cn("w-full h-full", className)}>
      <svg width="100%" height="100%" viewBox="0 0 700 400">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(33.33, 33.33)"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="66.6666667">
            <polyline points="463.333333 0 633.333333 166.666667 463.333333 333.333333"></polyline>
            <line x1="0" y1="166.666667" x2="556.666667" y2="166.666667"></line>
          </g>
          <rect x="0" y="0" width="700" height="400"></rect>
        </g>
      </svg>
    </div>
  );
}
